import React from 'react';

import ClickAwayListener from '@mui/material/ClickAwayListener';

import { calculatePhoneNumberChange } from '../utils/utils';

import CrmTextField from './CrmTextField';

function handleChange(isPhoneField, spaceFree, oldText, event, setTextFunc, setHaveEditedFunc) {
  const newText = event.target.value;
  // const visibleText = newText === '' ? '[empty]' : newText;
  // console.log(`In handleChange(); newText: ${visibleText}`);
  if (newText === oldText) {
    // console.log('  same as the old text; returning');
    return;
  }
  if (isPhoneField) {
    const phChange = calculatePhoneNumberChange(oldText, newText);
    if (phChange.shouldUpdate) {
      setHaveEditedFunc(true);
      setTextFunc(phChange.newValue);
    }
  } else if (spaceFree) {
    setHaveEditedFunc(true);
    const trimmedText = newText.trim();
    // const visibleText = trimmedText === '' ? '[empty]' : trimmedText;
    // console.log(`  calling setTextFunc(${visibleText})`);
    setTextFunc(trimmedText);
  } else {
    setHaveEditedFunc(true);
    setTextFunc(newText);
  }
}

const handleKeyUp = (event, multiline, outsideClickHandler, text) => {
  if (!multiline && event.key === 'Enter') {
    outsideClickHandler(text);
    event.preventDefault();
  }
};

const ClickAwayTextField = ({
  label,
  initialText,
  required,
  multiline,
  isPhoneField,
  spaceFree,
  outsideClickHandler,
}) => {
  // const visibleInitialText = initialText === '' ? '[empty]' : initialText === null ? '[null]' : initialText;
  // console.log(`Invoking ClickAwayTextField(); initialText: ${visibleInitialText}`);
  const [myText, setMyText] = React.useState(initialText);
  const [haveEdited, setHaveEdited] = React.useState(false);
  // console.log(`After hooks inits, myText: ${myText}; haveEdited: ${haveEdited}`);
  if (!haveEdited && initialText && myText !== initialText) {
    // console.log(`At invocation of ClickAwayTextField(); calling setMyText(${initialText})`);
    setMyText(initialText);
  }
  if (!haveEdited && initialText === null) {
    setMyText('');
    setHaveEdited(true);
  }

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={() => {
        setHaveEdited(false);
        outsideClickHandler(myText);
      }}
    >
      <div>
        <CrmTextField
          label={label}
          required={required}
          multiline={multiline}
          fullWidth
          value={myText}
          onChange={(event) => handleChange(isPhoneField, spaceFree, myText, event, setMyText, setHaveEdited)}
          onKeyUp={(event) => handleKeyUp(event, multiline, outsideClickHandler, myText)}
        />
      </div>
    </ClickAwayListener>
  );
};

export default ClickAwayTextField;
